import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Work in progress. 
        </p>
        <a
          className="App-link"
          href="https://artisanmodel.com"
          target="_blank"
          rel="noopener noreferrer"
        >
         Artisan Model 
        </a>
      </header>
    </div>
  );
}

export default App;
